// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blog-post .blogpost-heading-container {\n  padding: 16% 0 6%;\n  color: white;\n  text-align: center;\n}\n.blog-post .blogpost-heading-container h1 {\n  font-size: 38px;\n}\n.blog-post .blogpost-heading-container h2 {\n  font-size: 16px;\n}\n.blog-post .blog-content {\n  padding: 20px 20% 40px;\n  margin-bottom: 20px;\n}\n@media (max-width: 480px) {\n  .blog-post .blog-content {\n    padding: 20px 5% 40px;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
